import { ErrorPlug } from "shared/ui/errorPlug/ErrorPlug";

import notFoundPage from 'pages/404/ui/notFoundPage.gif';

export const NotFoundPage = () => {
    return (
        <ErrorPlug img={notFoundPage} text={'Страница не найдена'} link={true}/>
    );
};
